import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en, zh, es, ko, vi, ja, tl, hi } from './locales';

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			zh: { translation: zh },
			es: { translation: es },
			ko: { translation: ko },
			vi: { translation: vi },
			ja: { translation: ja },
			tl: { translation: tl },
			hi: { translation: hi },
		},
		fallbackLng: 'en',
		interpolation: {
			escapeValue: false,
		},
		detection: {
			order: ['localStorage', 'querystring', 'navigator'],
			lookupLocalStorage: 'i18nextLng',
			caches: ['localStorage'],
		},
	});

export default i18n;
